import { localStorageEffect } from '@elementary/common-ui/atoms/atoms';
import {
  SnackbarVariant,
  SnackbarAction,
} from '@elementary/common-ui/components';
import { atom } from 'recoil';

export const snackbar = atom<{
  open: boolean;
  variant?: SnackbarVariant;
  message?: string;
  actions?: SnackbarAction[];
}>({
  key: 'frontendSnackbar',
  default: { open: false },
});

export const latestPullRequestTimestamp = atom<string>({
  key: 'latestPullRequestTimestamp',
  default: undefined,
});

export const pollingTests = atom<Set<string>>({
  key: 'pollingTests',
  default: new Set(),
});

// The account's Boomi flag from its last visit in this browser, used for the
// same account until it loads so a flagged account doesn't flash the
// Elementary look. Remove it with the Elementary look, once every account
// gets Boomi.
export const accountBoomiLook = atom<
  { accountId: string; isBoomiLookEnabled: boolean } | undefined
>({
  key: 'accountBoomiLook',
  default: undefined,
  effects: [localStorageEffect('account_boomi_look')],
});
